import { Box, Flex } from '@chakra-ui/react'
import { FaFrown, FaHeart, FaMedal, FaTools } from 'react-icons/fa'
import { CheckboxCmp } from '../../../../../components/CheckboxCmp'
import { iDadoLinha, iItensATrabalhar } from '../../../../../interfaces'
import { GroupBy } from '../../../../../Utils/Helper'
import { iSelo } from '../../../../PesquisaIndicativa/ResultadoIndividualIndicativa'
import { Container } from './styles'

interface iProps {
  model: iItensATrabalhar
  OnCheck?: (val: boolean, competencia: string) => void
}

interface linhatabela {
  competencia: string
  dados: iDadoLinha[]
}

export const TabelaItensAMelhorar: React.FC<iProps> = ({ model, OnCheck }) => {
  function ObterIcone2(obj: iSelo): any {
    if (obj.selo === 4) {
      return <FaMedal style={{ color: 'var(--Green2)', fontSize: '18px' }} />
    } else if (obj.selo === 1) {
      return <FaTools style={{ color: 'var(--Orange)', fontSize: '18px' }} />
    } else if (obj.selo === 2) {
      return <FaHeart style={{ color: 'var(--Azul)', fontSize: '18px' }} />
    } else if (obj.selo === 3) {
      return <FaFrown style={{ color: 'var(--Roxo)', fontSize: '18px' }} />
    } else {
      return <></>
    }
  }

  function GetLinha(): linhatabela[] {
    const dados: linhatabela[] = []
    const competencias: string[] = []
    model.linhaTabela.forEach(e => e.dados.forEach(d => {
      if (!competencias.includes(d.competencia)) {
        competencias.push(d.competencia)
      }
    }))
    model.linhaTabela.forEach(e => {
      competencias.forEach(comp => {
        const indexComp = e.dados.findIndex(c => c.competencia === comp)
        if (indexComp !== -1) {
          if (dados.some(d => d.competencia === comp)) {
            const index = dados.findIndex(d => d.competencia === comp)
            const linha = e.dados.find(dad => dad.competencia === comp)
            if (linha) dados[index].dados.push(linha)
          } else {
            const linha = e.dados.find(dad => dad.competencia === comp)
            if (linha) {
              dados.push({
                competencia: comp,
                dados: [linha]
              })
            }
          }
        } else {
          const index = dados.findIndex(d => d.competencia === comp)
          if (index !== -1) {
            dados[index].dados.push({ competencia: comp, vazio: true, mediaSemAuto: '0,00', selos2: [] })
          } else {
            dados.push({ competencia: comp, dados: [{ competencia: comp, vazio: true, mediaSemAuto: '0,00', selos2: [] }] })
          }
        }
      })
    })

    return dados
  }

  function RenderizarBloco(selos: iSelo[]): any {
    return (
    <td>
        <Flex justifyContent={'center'}
            gap={'.5rem'}
        >
            {GroupBy(selos, (r) => r.selo).toList().map((a, i) => {
              return (
                <Flex key={i} gap={'.325rem'} alignItems={'center'} fontWeight={'600'}>
                    {a.data.length > 1 ? a.data.length : ''}
                    {ObterIcone2(a.data[0])}
                </Flex>
              )
            })}
        </Flex>
    </td>
    )
  }
  return (
        <Box padding={'.5rem'} border={OnCheck ? '1px solid var(--c6)' : undefined} borderTop={OnCheck ? undefined : '1px solid var(--c6)'} borderRadius={OnCheck ? '.25rem' : undefined}>
            <Container>
                <thead>
                    <tr>
                        <th>Competências</th>
                        {model.linhaTabela.map(e => {
                          return <th>{e.nomePesquisa}</th>
                        })}
                    </tr>
                </thead>
                <tbody>
                    {GetLinha().map((linha, i) => {
                      return (
                        <tr key={i}>
                          {OnCheck && <td>
                            <CheckboxCmp isChecked={model.selecionadas.includes(linha.competencia)} OnChange={(val) => OnCheck(val, linha.competencia)}>
                              {linha.competencia}
                            </CheckboxCmp>
                          </td>}
                          {!OnCheck && <td>
                            {linha.competencia}
                          </td>}
                          {linha.dados.map(e => {
                            return <>
                              {!e.vazio && (e.selos2.length === 0 ? <td>{e.mediaSemAuto}</td> : RenderizarBloco(e.selos2))}
                              {e.vazio && <td>-</td>}
                            </>
                          })}
                        </tr>
                      )
                    })
                    }
                </tbody>
            </Container>
        </Box>
  )
}
